export const box = {
  variants: {
    shadow: {
      boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.16)',
    },
  },
};
